import { VetClinicMarker } from "pages/veterinarkartan";
import { ClinicListItem } from "./ClinicListItem";
import styles from "./ClinicList.module.css";

export const ClinicList = ({
  markers,
  selectedClinicId,
  onClinicPress,
}: {
  markers: VetClinicMarker[];
  selectedClinicId: string | null;
  onClinicPress: (marker: VetClinicMarker) => void;
}) => {
  if (markers.length === 0) {
    return null;
  }

  const handleClinicPress = (marker: VetClinicMarker) => {
    onClinicPress(marker);
  };

  return (
    <div className={styles.clinicList}>
      <ul className={styles.clinicListItems}>
        {markers
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((marker) => {
            return (
              <ClinicListItem
                key={marker.id}
                marker={marker}
                onPress={handleClinicPress}
                selected={selectedClinicId === marker.id}
              />
            );
          })}
      </ul>
    </div>
  );
};
